export const INSTRUMENTS_OPTIONS = [
  'Posterior Spinal Fusion',
  'Anterior Spinal Fusion',
  'Trauma Fracture Fixation',
  'Total Hip Arthroplasty',
  'Total Knee Arthroplasty',
  'Globus Xtend Cervical Plate Set',
  'Globus Xtend Screw Set',
  'Globus Creo Threaded Degen Implants Screw Sub Tray',
  'Globus Creo Threaded Degen Implants Screw Sub Tray',
]

export const MAIN_OPTIONS = ['Loaner', 'Consigned']

export type TInstrumentsProps = {
  selectedInstruments: string[]
  onChange: (selectedOptions: string[]) => void
}
